import { formatVnDateTime } from "@apv-erp/status";

/** Việc khác trên cùng máy bị chồng khi planner sửa tay giờ / máy (máy chủ trả HTTP 409) */
export interface ScheduleConflict {
  stepId: string;
  stepName: string;
  poCode: string;
  status?: string;
  locked?: boolean;
  start: string;
  end: string;
}

/** Lấy danh sách chồng lịch từ lỗi tRPC 409 (data.scheduleConflicts); null nếu không phải cảnh báo chồng lịch */
export function getScheduleConflicts(err: unknown): ScheduleConflict[] | null {
  const e = err as any;
  const list = e?.data?.scheduleConflicts ?? e?.shape?.data?.scheduleConflicts;
  return Array.isArray(list) && list.length > 0 ? (list as ScheduleConflict[]) : null;
}

export function describeScheduleConflict(c: ScheduleConflict): string {
  return `${c.poCode} – ${c.stepName} (${formatVnDateTime(c.start)} → ${formatVnDateTime(c.end)})${c.locked ? " · đã khóa" : ""}`;
}
